<template>
	<div class="container">
		<div class="content">
			<!-- 主要内容 -->
			<div class="main-content">
				<div class="left-column">
					<!-- 理赔流程 -->
					<div class="card" v-if="processSteps && processSteps.length > 0">
						<div class="card-title">
							<i class="el-icon-s-claim"></i>
							理赔流程
						</div>

						<div class="claim-process">
							<div class="process-step" v-for="(step, index) in processSteps" :key="index">
								<div class="step-number">{{ index + 1 }}</div>
								<div class="step-content">
									<h3>{{ step.title }}</h3>
									<p>{{ step.description }}</p>
								</div>
							</div>
						</div>
					</div>

					<!-- 所需材料 -->
					<div class="card" v-if="materialItems && materialItems.length > 0">
						<div class="card-title">
							<i class="el-icon-s-claim"></i>
							理赔所需材料
						</div>

						<div class="materials-grid">
							<div class="material-item" v-for="(item, index) in materialItems" :key="index">
								<div class="material-icon">
									<i :class="item.icon"></i>
								</div>
								<div class="material-text">
									<h3>{{ item.title }}</h3>
									<p>{{ item.description }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 侧边栏 -->
				<div class="sidebar">
					<!-- 联系客服 -->
					<div class="contact-card">
						<h3><i class="el-icon-phone"></i> 理赔咨询</h3>
						<div class="contact-info">
							<p>客服热线：{{ $getter('setting').value1 }}</p>
							<p>服务时间：{{ $getter('setting').value4 }}</p>
							<p v-if="$getter('setting') && $getter('setting').value5">
								24小时紧急救援：{{ $getter('setting').value5 }}
							</p>
						</div>
					</div>

					<!-- 理赔小贴士 -->
					<div class="card tips-card" v-if="tipItems && tipItems.length > 0">
						<div class="card-title">
							<i class="el-icon-s-opportunity"></i>
							理赔小贴士
						</div>
						<ul>
							<li v-for="(tip, index) in tipItems" :key="index">
								<i class="el-icon-success"></i>
								<span><strong>{{ tip.title }}：</strong>{{ tip.content }}</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<mainFooter />
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';
	export default {
		components: {
			mainFooter,
		},
		data() {
			return {
				processSteps: [],
				materialItems: [],
				tipItems: []
			}
		},
		mounted() {
			this.getPageData();
		},
		methods: {
			getPageData() {
				this.$get('app-page-design/4').then(res => {
					if (res.data && res.data.content) {
						try {
							const data = typeof res.data.content === 'string' ? 
								JSON.parse(res.data.content) : res.data.content;
							
							this.processSteps = data.processSteps || [];
							this.materialItems = data.materialItems || [];
							this.tipItems = data.tipItems || [];
						} catch (error) {
							console.error('解析页面数据失败:', error);
							this.initDefaultData();
						}
					} else {
						this.initDefaultData();
					}
				}).catch(err => {
					console.error('获取页面数据失败:', err);
					this.initDefaultData();
				});
			},
			
			initDefaultData() {
				// 如果获取数据失败，使用默认数据
				this.processSteps = [
					{
						title: '报案通知',
						description: '发生保险事故后，请第一时间拨打我们的24小时客服热线400-123-4567报案，或通过在线渠道提交报案信息。'
					},
					{
						title: '准备材料',
						description: '根据客服指引准备理赔所需材料，包括身份证明、医疗单据、事故证明等，确保材料真实完整。'
					},
					{
						title: '提交申请',
						description: '通过官方网站、APP或邮寄方式提交理赔申请及相关材料，我们将在收到材料后1个工作日内确认受理。'
					},
					{
						title: '审核处理',
						description: '我们的专业团队将对您的理赔申请进行审核，如有需要可能会与您联系补充材料，一般案件5-7个工作日内完成审核。'
					},
					{
						title: '理赔支付',
						description: '审核通过后，理赔款项将在3个工作日内支付到您指定的银行账户，并发送通知短信。'
					}
				];
				
				this.materialItems = [
					{
						icon: 'el-icon-s-custom',
						title: '身份证明',
						description: '投保人、被保险人及受益人的有效身份证件'
					},
					{
						icon: 'el-icon-s-management',
						title: '医疗单据',
						description: '病历、诊断证明、医疗费用原始凭证等'
					},
					{
						icon: 'el-icon-warning',
						title: '事故证明',
						description: '警方报告、事故鉴定书等相关证明文件'
					},
					{
						icon: 'el-icon-warning',
						title: '费用凭证',
						description: '交通费、住宿费等相关费用的原始票据'
					},
					{
						icon: 'el-icon-s-order',
						title: '保单凭证',
						description: '电子或纸质保单、投保确认书等'
					},
					{
						icon: 'el-icon-s-finance',
						title: '银行账户',
						description: '受益人有效银行账户信息'
					}
				];
				
				this.tipItems = [
					{
						title: '及时报案',
						content: '出险后请第一时间报案，保留现场证据'
					},
					{
						title: '保管票据',
						content: '妥善保管所有原始票据和证明文件'
					},
					{
						title: '如实填写',
						content: '如实填写理赔申请，避免因信息不实影响理赔'
					},
					{
						title: '关注进度',
						content: '关注理赔进度，及时补充所需材料'
					},
					{
						title: '及时沟通',
						content: '如有疑问，及时联系客服获取专业指导'
					}
				];
			}
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;

		.content {
			min-height: calc(100vh - 300px);
			margin: 20px auto 40px;
			width: 68%;

			/* 页面标题 */
			.page-header {
				background: white;
				padding: 30px 0;
				text-align: center;
				margin-bottom: 30px;
				box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
				border-radius: 12px;
			}

			.page-header h1 {
				font-size: 28px;
				font-weight: 600;
				margin-bottom: 10px;
				color: #333;
			}

			.page-header p {
				font-size: 16px;
				color: #666;
				max-width: 700px;
				margin: 0 auto;
			}

			/* 主要内容区域 */
			.main-content {
				display: grid;
				grid-template-columns: 1fr;
				gap: 25px;
			}

			@media (min-width: 992px) {
				.main-content {
					grid-template-columns: 2fr 1fr;
				}
			}

			/* 卡片样式 */
			.card {
				background: white;
				border-radius: 12px;
				padding: 30px;
				box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
				transition: transform 0.3s ease, box-shadow 0.3s ease;
				margin-bottom: 20px;
			}

			.card:hover {
				transform: translateY(-3px);
				box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
			}

			.card-title {
				font-size: 22px;
				font-weight: 600;
				margin-bottom: 20px;
				color: #333;
				display: flex;
				align-items: center;
				gap: 12px;
				padding-bottom: 15px;
				border-bottom: 1px solid #f0f0f0;
			}

			.card-title i {
				color: #2280FD;
			}

			/* 理赔流程 */
			.claim-process {
				display: flex;
				flex-direction: column;
				gap: 25px;
				margin-bottom: 30px;
			}

			.process-step {
				display: flex;
				align-items: flex-start;
				gap: 20px;
				padding: 20px;
				background: #f9fafb;
				border-radius: 10px;
				border-left: 4px solid #2280FD;
				transition: all 0.3s ease;
			}

			.process-step:hover {
				background: #f0f7ff;
				transform: translateX(5px);
			}

			.step-number {
				width: 40px;
				height: 40px;
				background: #2280FD;
				color: white;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 18px;
				font-weight: 600;
				flex-shrink: 0;
			}

			.step-content h3 {
				font-size: 18px;
				font-weight: 600;
				margin-bottom: 10px;
				color: #333;
			}

			.step-content p {
				font-size: 15px;
				color: #666;
				line-height: 1.6;
			}

			/* 所需材料 */
			.materials-grid {
				display: grid;
				grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
				gap: 20px;
			}

			.material-item {
				display: flex;
				flex-direction: column;
				align-items: center;
				text-align: center;
				padding: 20px 15px;
				background: #f9fafb;
				border-radius: 10px;
				transition: all 0.3s ease;
			}

			.material-item:hover {
				background: #f0f7ff;
				transform: translateY(-5px);
			}

			.material-icon {
				width: 60px;
				height: 60px;
				background: rgba(34, 128, 253, 0.1);
				color: #2280FD;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 24px;
				margin-bottom: 15px;
			}

			.material-text h3 {
				font-size: 16px;
				font-weight: 600;
				margin-bottom: 8px;
				color: #333;
			}

			.material-text p {
				font-size: 14px;
				color: #666;
				line-height: 1.5;
			}

			/* 常见问题 */
			.faq-list {
				display: flex;
				flex-direction: column;
				gap: 15px;
			}

			.faq-item {
				border-radius: 8px;
				overflow: hidden;
				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
				transition: all 0.3s ease;
			}

			.faq-item:hover {
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
			}

			.faq-question {
				background: #f9f9f9;
				padding: 18px 20px;
				font-size: 16px;
				font-weight: 600;
				color: #333;
				cursor: pointer;
				display: flex;
				justify-content: space-between;
				align-items: center;
				transition: background 0.3s;
			}

			.faq-question:hover {
				background: #f0f0f0;
			}

			.faq-question i {
				color: #2280FD;
				transition: transform 0.3s;
			}

			.faq-answer {
				padding: 0 20px;
				max-height: 0;
				overflow: hidden;
				transition: all 0.3s ease;
				background: white;
			}

			.faq-answer p {
				padding: 15px 0;
				font-size: 15px;
				color: #666;
				line-height: 1.6;
			}

			.faq-item.active .faq-answer {
				max-height: 500px;
			}

			.faq-item.active .faq-question i {
				transform: rotate(180deg);
			}

			/* 侧边栏 */
			.sidebar {
				display: flex;
				flex-direction: column;
				gap: 25px;
			}

			.contact-card {
				background: linear-gradient(135deg, #2280FD 0%, #1a6fd0 100%);
				color: white;
				border-radius: 12px;
				padding: 25px;
				text-align: center;
			}

			.contact-card h3 {
				font-size: 20px;
				margin-bottom: 15px;
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 10px;
			}

			.contact-info {
				margin-bottom: 20px;
			}

			.contact-info p {
				margin-bottom: 8px;
				font-size: 15px;
			}

			.contact-btn {
				display: inline-block;
				background: white;
				color: #2280FD;
				padding: 12px 25px;
				border-radius: 8px;
				font-weight: 600;
				text-decoration: none;
				transition: all 0.3s;
			}

			.contact-btn:hover {
				transform: translateY(-2px);
				box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
			}

			.tips-card ul {
				list-style: none;
				padding-left: 0;
			}

			.tips-card li {
				padding: 12px 0;
				border-bottom: 1px solid #f0f0f0;
				display: flex;
				align-items: flex-start;
				gap: 10px;
			}

			.tips-card li:last-child {
				border-bottom: none;
			}

			.tips-card i {
				color: #2280FD;
				margin-top: 3px;
			}

			.tips-card span strong {
				color: #333;
			}

			.emergency-card {
				background: #fff8e1;
				border-left: 4px solid #ffc107;
				padding: 20px;
				border-radius: 8px;
			}

			.emergency-card h3 {
				color: #e65100;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				gap: 8px;
			}

			.emergency-card p {
				color: #666;
				margin-bottom: 10px;
			}
			
			.emergency-card i{
				font-size: 24px;
			}

			/* 理赔类型 */
			.claim-types {
				display: grid;
				grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
				gap: 15px;
				margin-top: 20px;
			}

			.claim-type {
				background: #f9fafb;
				padding: 15px;
				border-radius: 8px;
				text-align: center;
				transition: all 0.3s;
			}

			.claim-type:hover {
				background: #f0f7ff;
				transform: translateY(-3px);
			}

			.claim-type i {
				font-size: 24px;
				color: #2280FD;
				margin-bottom: 10px;
			}

			.claim-type h4 {
				font-size: 16px;
				font-weight: 600;
				margin-bottom: 5px;
			}

			/* 行动按钮 */
			.action-section {
				background: white;
				padding: 30px;
				text-align: center;
				border-radius: 12px;
				box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
			}

			.action-buttons {
				display: flex;
				gap: 15px;
				justify-content: center;
				flex-wrap: wrap;
			}

			.btn {
				padding: 14px 30px;
				border: none;
				border-radius: 8px;
				font-size: 16px;
				font-weight: 600;
				cursor: pointer;
				transition: all 0.3s ease;
				display: flex;
				align-items: center;
				gap: 8px;
			}

			.btn-primary {
				background: #2280FD;
				color: white;
				box-shadow: 0 4px 12px rgba(34, 128, 253, 0.3);
			}

			.btn-primary:hover {
				background: #1a6fd0;
				transform: translateY(-2px);
				box-shadow: 0 6px 15px rgba(34, 128, 253, 0.4);
			}

			.btn-secondary {
				background: white;
				color: #2280FD;
				border: 1.5px solid #2280FD;
			}

			.btn-secondary:hover {
				background: rgba(34, 128, 253, 0.05);
				transform: translateY(-2px);
			}

			/* 页脚 */
			.footer {
				background: #333;
				color: #ccc;
				padding: 40px 0;
				text-align: center;
				margin-top: 50px;
			}

			.footer-content {
				max-width: 800px;
				margin: 0 auto;
			}

			.footer p {
				margin-bottom: 10px;
				font-size: 14px;
			}

			/* 动画效果 */
			@keyframes fadeIn {
				from {
					opacity: 0;
					transform: translateY(20px);
				}

				to {
					opacity: 1;
					transform: translateY(0);
				}
			}

			.card {
				animation: fadeIn 0.5s ease-out;
			}

			.process-step {
				animation: fadeIn 0.5s ease-out;
				animation-fill-mode: both;
			}

			.process-step:nth-child(1) {
				animation-delay: 0.1s;
			}

			.process-step:nth-child(2) {
				animation-delay: 0.2s;
			}

			.process-step:nth-child(3) {
				animation-delay: 0.3s;
			}

			.process-step:nth-child(4) {
				animation-delay: 0.4s;
			}

			.process-step:nth-child(5) {
				animation-delay: 0.5s;
			}
		}
	}
</style>